import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { action } from 'mobx';
import axios from 'axios';
import { Row, Col, Button, Label, Card, CardBody, Modal } from 'reactstrap';
import { AvForm, AvGroup } from 'availity-reactstrap-validation';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import moment from 'moment';
import uuid from 'react-uuid';
import ProgressBar from '../../Common/components/ProgressBar';
import ErrorPopup from '../ErrorWindow/error-popup';
import qualityStore from '../stores/QualityStore';

@observer
export default class ReviewSubmit extends Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    if (qualityStore.getPageStatus('#reviewsubmit') !== 'stepwizard-step active') {
      qualityStore.setPageStatus('#reviewsubmit', 'active');
    }
  }

  componentDidMount = () => {
    qualityStore.disableAllEdits();
  }

  componentWillUnmount = () => {
    qualityStore.setPageStatus('#reviewsubmit', 'disabled');
  }

  toggleModal = () => {
    const { history } = this.props;
    if (qualityStore.errorCount > 0) {
      qualityStore.setOpenModal();
    } else {
      qualityStore.disablePages();
      qualityStore.clearIncidentForm();
      qualityStore.setOpenModal();
      history.push('/');
    }
  }

  enableEdit = event => {
    const { id } = event.target;
    qualityStore.updateEnable(id);
  }
  disableEdit = event => {
    const { id } = event.target;
    qualityStore.disableEnable(id);
  }
  editReportFields = event => {
    const { id, value } = event.target;
    qualityStore.updateReporter(id, value);
  }

  @action handleSubmit() {
    qualityStore.turnOnBlocking();
    const props = this.props;
    const postUrl = '/flriskmangmntreport/public/provconn/providers/submitrmir';
    const data = qualityStore.submitIncident();

    axios({
      method: 'post',
      url: postUrl,
      data: data
    })
      .then(function (response) {
        qualityStore.turnOffBlocking();
        if (response && response.status === 200) {
          qualityStore.confirmationId = response.data.pyID;
          qualityStore.submitSuccess = true;
          props.history.push('/confirmation');
        }
        if (response.data.pyID === null) {
          qualityStore.incrementErrorCount();
          qualityStore.setOpenModal();
        }
        return response;
      })
      .catch(function (error) {
        qualityStore.incrementErrorCount();
        qualityStore.turnOffBlocking();
        qualityStore.setOpenModal();
        return error;
      });
  }

  render() {
    const {
      firstName,
      lastName,
      preparerOrg,
      department,
      jobTitle,
      repPhone,
      datetoDisplay,
      extension,
      errorCount
    } = qualityStore;

    const {
      member, pg, authRep
    } = qualityStore;

    const {
      practitioner, location, practitionerList
    } = qualityStore;

    const {
      incidentCategories,
      incident,
      physOrBehavior,
      memHospitalized,
      originalAdmission,
      dischargeDate,
      memReadmitted,
      readmissionDate,
      readmissDischargeDate,
      openModal
    } = qualityStore;

    const {
      editReporter, editMember, editFacility, editIncident
    } = qualityStore;

    return (
      <Card>
        {/* Error Popup */}
        <Modal className="errorModal" isOpen={openModal} toggle={this.toggleModal}>
          <ErrorPopup errorCount={errorCount} />
        </Modal>
        {/* Error Popup */}
        <CardBody className="p-40">
          <ProgressBar />
          <div className="border-form">
            <AvForm onValidSubmit={this.handleSubmit}>
              <h2 className="primarycardTitle">{'Review and Submit'}</h2>
              <div className='spacer' />
              <Row>
                <Col xs="9" sm="9" md="9">
                  <h5><b>Preparer Information</b></h5>
                  <div className='reviewTitleSpacer' />
                </Col>
                <Col className="editConfirm" xs="3" sm="3" md="3">
                  <NavLink exact to="/preparerinfo" className={'btn btn-link'}>
                    Edit
                </NavLink>
                </Col>
              </Row>
              <Row>
                <Col xs="12" sm="4" md="4">
                  <AvGroup>
                    <Label htmlFor="rev_preparer_first">
                      <b>First Name</b>
                    </Label>
                    <div>
                      {firstName}
                    </div>
                  </AvGroup>
                </Col>
                <Col xs="12" sm="4" md="4">
                  <AvGroup>
                    <Label htmlFor="rev_preparer_last">
                      <b>Last Name</b>
                    </Label>
                    <div>
                      {lastName}
                    </div>
                  </AvGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="12" sm="4" md="4">
                  <AvGroup>
                    <Label htmlFor="revRepOrg">
                      <b>Organization</b>
                    </Label>
                    <div>
                      {preparerOrg}
                    </div>
                  </AvGroup>
                </Col>
                <Col xs="12" sm="4" md="4">
                  <AvGroup>
                    <Label htmlFor="revRepDept">
                      <b>Department</b>
                    </Label>
                    <div>
                      {department}
                    </div>
                  </AvGroup>
                </Col>
                <Col xs="12" sm="4" md="4">
                  <AvGroup>
                    <Label htmlFor="revRepJob">
                      <b>Job Title</b>
                    </Label>
                    <div>
                      {jobTitle}
                    </div>
                  </AvGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="12" sm="4" md="4">
                  <AvGroup>
                    <Label htmlFor="revRepPhone">
                      <b>Phone Number</b>
                    </Label>
                    <div>
                      {repPhone}
                    </div>
                  </AvGroup>
                </Col>
                <Col xs="12" sm="4" md="4">
                  <AvGroup>
                    <Label htmlFor="revRepExt">
                      <b>Ext.</b>
                    </Label>
                    <div>
                      {extension}
                    </div>
                  </AvGroup>
                </Col>
                <Col xs="12" sm="4" md="4">
                  <AvGroup>
                    <Label htmlFor="revRepDate">
                      <b>Date of Report</b>
                    </Label>
                    <div>
                      {datetoDisplay}
                    </div>
                  </AvGroup>
                </Col>
              </Row>
              <hr className="spacer-both" />
              <Row>
                <Col xs="9" sm="9" md="9">
                  <h5><b>Member Information</b></h5>
                  <div className='reviewTitleSpacer' />
                </Col>
                <Col className="editConfirm" xs="3" sm="3" md="3">
                  <NavLink exact to="/memberinfo" className={'btn btn-link'}>
                    Edit
                </NavLink>
                </Col>
              </Row>
              <Row>
                <Col xs="12" sm="4" md="4">
                  <AvGroup>
                    <Label htmlFor="revMemName">
                      <b>Member Name</b>
                    </Label>
                    <div>
                      {`${member.memberFirst} ${member.memberInitial} ${member.memberLast}`}
                    </div>
                  </AvGroup>
                </Col>
                <Col xs="12" sm="4" md="4">
                  <AvGroup>
                    <Label htmlFor="revHbId">
                      <b>Subscriber ID</b>
                    </Label>
                    <div>
                      {`${member.subscriberId}`}
                    </div>
                  </AvGroup>
                </Col>
                <Col xs="12" sm="4" md="4">
                  <AvGroup>
                    <Label htmlFor="revMemAddr">
                      <b>Member Address</b>
                    </Label>
                    <div>
                      {`${member.memStreetSuite} ${member.memCity}, ${member.memState} ${member.memZip}`}
                    </div>
                  </AvGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="12" sm="4" md="4">
                  <AvGroup>
                    <Label htmlFor="revMemPhone">
                      <b>Member Phone</b>
                    </Label>
                    <div>
                      {member.memPhone}
                    </div>
                    <div>
                      {member.memPhoneType}
                    </div>
                  </AvGroup>
                </Col>
                <Col xs="12" sm="4" md="4">
                  <AvGroup>
                    <Label htmlFor="revMemDOB">
                      <b>Member Date of Birth</b>
                    </Label>
                    <div>
                      {member.memDOB && moment(member.memDOB).format('MM/DD/YYYY')}
                    </div>
                  </AvGroup>
                </Col>
                <Col xs="12" sm="4" md="4">
                  <AvGroup>
                    <Label htmlFor="underAge">
                      <b>Is member under 18?</b>
                    </Label>
                    <div>
                      {member.isMemberMinor}
                    </div>
                  </AvGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="12" sm="4" md="4">
                  <AvGroup>
                    <Label htmlFor="revMemPG">
                      <b>Parent/Guardian</b>
                    </Label>
                    <div>
                      {`${pg.pgFirstName} ${pg.pgMiddleInitial} ${pg.pgLastName}`}
                    </div>
                  </AvGroup>
                </Col>
                <Col xs="12" sm="4" md="4">
                  <AvGroup>
                    <Label htmlFor="revMemRelation">
                      <b>Relationship to Member</b>
                    </Label>
                    <div>
                      {pg.pgRelation}
                    </div>
                  </AvGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="12" sm="4" md="4">
                  <AvGroup>
                    <Label htmlFor="revMemAuthRep">
                      <b>Authorized Representative</b>
                    </Label>
                    <div>
                      {`${authRep.authRepFirstName} ${authRep.authRepMiddleInitial} ${authRep.authRepLastName}`}
                    </div>
                  </AvGroup>
                </Col>
                <Col xs="12" sm="4" md="4">
                  <AvGroup>
                    <Label htmlFor="revMemAuthRelation">
                      <b>Relationship to Member</b>
                    </Label>
                    <div>
                      {authRep.authRelation}
                    </div>
                  </AvGroup>
                </Col>
              </Row>
              <hr className="spacer-both" />
              <Row>
                <Col xs="9" sm="9" md="9">
                  <h5><b>{`Provider & Location Information`}</b></h5>
                  <div className='reviewTitleSpacer' />
                </Col>
                <Col className="editConfirm" xs="3" sm="3" md="3">
                  <NavLink exact to="/practitionerlocation" className={'btn btn-link'}>
                    Edit
                </NavLink>
                </Col>
              </Row>
              <Row>
                <Col xs="12" sm="4" md="4">
                  <AvGroup>
                    <Label htmlFor="revFacilityPractName_1">
                      <b>Provider 1 Name</b>
                    </Label>
                    <div>
                      {`${practitioner.practFirst} ${practitioner.practLast}`}
                    </div>
                  </AvGroup>
                </Col>
                <Col xs="12" sm="4" md="4">
                  <AvGroup>
                    <Label htmlFor="revFacilityPractNPI_1">
                      <b>Provider 1 NPI</b>
                    </Label>
                    <div>
                      {practitioner.pracNPI}
                    </div>
                  </AvGroup>
                </Col>
              </Row>
              <Row>
                {
                  practitionerList.map((pract, i) => (
                    <>
                      <Col xs="12" sm="4" md="4" key={i}>
                        <AvGroup>
                          <Label htmlFor={`revFacilityPractName_${i}`}>
                            <b>{`Provider ${i + 2} Name`}</b>
                          </Label>
                          <div>
                            {`${pract.practFirst} ${pract.practLast}`}
                          </div>
                        </AvGroup>
                      </Col>
                      <Col xs="12" sm="4" md="4">
                        <AvGroup>
                          <Label htmlFor={`revFacilityPractNPI_${i}`}>
                            <b>{`Provider ${i + 2} NPI`}</b>
                          </Label>
                          <div>
                            {pract.pracNPI}
                          </div>
                        </AvGroup>
                      </Col>
                    </>
                  ))
                }
              </Row>
              <Row>
                <Col xs="12" sm="4" md="4">
                  <AvGroup>
                    <Label htmlFor="revFacilityContact">
                      <b>Contact Name</b>
                    </Label>
                    <div>
                      {`${location.contactFirst} ${location.contactLast}`}
                    </div>
                  </AvGroup>
                </Col>
                <Col xs="12" sm="4" md="4">
                  <AvGroup>
                    <Label htmlFor="revFacilityPhone">
                      <b>Contact Phone-ext</b>
                    </Label>
                    <div>
                      {location.contactPhoneExt}
                    </div>
                  </AvGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="12" sm="4" md="4">
                  <AvGroup>
                    <Label htmlFor="revFacilityName">
                      <b>Location Name</b>
                    </Label>
                    <div>
                      {location.name}
                    </div>
                  </AvGroup>
                </Col>
                <Col xs="12" sm="4" md="4">
                  <AvGroup>
                    <Label htmlFor="revFacilityStreet">
                      <b>Street Address/Suite Number</b>
                    </Label>
                    <div>
                      {`${location.streetSuite} ${location.city}, ${location.state} ${location.zip}`}
                    </div>
                  </AvGroup>
                </Col>
              </Row>
              <hr className="spacer-both" />
              <Row>
                <Col xs="9" sm="9" md="9">
                  <h5><b>Incident Details</b></h5>
                  <div className='reviewTitleSpacer' />
                </Col>
                <Col className="editConfirm" xs="3" sm="3" md="3">
                  <NavLink exact to="/incidentdetails" className={'btn btn-link'}>
                    Edit
                </NavLink>
                </Col>
              </Row>
              <Row>
                <Col xs="12" sm="4" md="4">
                  <AvGroup>
                    <Label htmlFor="revIncidentCat">
                      <b>Categories</b>
                    </Label>
                    {
                      incidentCategories.map(incidentCategory => (
                        <div key={uuid()}>
                          {incidentCategory}
                        </div>
                      ))
                    }
                  </AvGroup>
                </Col>
                <Col xs="12" sm="4" md="4">
                  <AvGroup>
                    <Label htmlFor="revIncidentType">
                      <b>Incident Type</b>
                    </Label>
                    <div>
                      {physOrBehavior}
                    </div>
                  </AvGroup>
                </Col>
                <Col xs="12" sm="4" md="4">
                  <AvGroup>
                    <Label htmlFor="revIncidentRepeat">
                      <b>Did the incident occur more than once?</b>
                    </Label>
                    <div>
                      {incident.incidentRepeat}
                    </div>
                  </AvGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="12" sm="4" md="4">
                  <AvGroup>
                    <Label htmlFor="revIncidentDates">
                      {incident.incidentRepeat === 'Yes' ? <b>{`Dates of Incident`}</b> : <b>{`Date of Incident`}</b>}
                    </Label>
                    <div>
                      {incident.incidentRepeat === 'Yes' ?
                        `${incident.incidentStart && moment(incident.incidentStart).format("MM/DD/YYYY")} - ${incident.incidentEnd && moment(incident.incidentEnd).format("MM/DD/YYYY")}`
                        : incident.incidentStart && moment(incident.incidentStart).format("MM/DD/YYYY")}
                    </div>
                  </AvGroup>
                </Col>
                <Col xs="12" sm="4" md="4">
                  <AvGroup>
                    <Label htmlFor="memHospLbl">
                      <b>Member Hospitalized</b>
                    </Label>
                    <div>
                      {memHospitalized}
                    </div>
                  </AvGroup>
                </Col>
                <Col xs="12" sm="4" md="4">
                  <AvGroup>
                    <Label htmlFor="originalAdmissionLbl">
                      <b>Original Admission Date</b>
                    </Label>
                    <div>
                      {originalAdmission && moment(originalAdmission).format("MM/DD/YYYY")}
                    </div>
                  </AvGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="12" sm="4" md="4">
                  <AvGroup>
                    <Label htmlFor="dischargeDateLbl">
                      <b>Discharge Date</b>
                    </Label>
                    <div>
                      {dischargeDate && moment(dischargeDate).format("MM/DD/YYYY")}
                    </div>
                  </AvGroup>
                </Col>
                <Col xs="12" sm="4" md="4">
                  <AvGroup>
                    <Label htmlFor="readmit30Lbl">
                      <b>Readmitted within last 30 days?</b>
                    </Label>
                    <div>
                      {memReadmitted}
                    </div>
                  </AvGroup>
                </Col>
                <Col xs="12" sm="4" md="4">
                  <AvGroup>
                    <Label htmlFor="readmissionDateLbl">
                      <b>Readmission Date</b>
                    </Label>
                    <div>
                      {readmissionDate && moment(readmissionDate).format("MM/DD/YYYY")}
                    </div>
                  </AvGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="12" md="4">
                  <AvGroup>
                    <Label htmlFor="dischargeLbl">
                      <b>Discharge Date</b>
                    </Label>
                    <div>
                      {readmissDischargeDate && moment(readmissDischargeDate).format("MM/DD/YYYY")}
                    </div>
                  </AvGroup>
                </Col>
                <Col xs="12" sm="12" md="8">
                  <AvGroup>
                    <Label htmlFor="revIncidentDetails">
                      <b>Additional Details</b>
                    </Label>
                    <div>
                      {incident.additionalDetails}
                    </div>
                  </AvGroup>
                </Col>
              </Row>
              <Button type="submit" color={"primary"} className={"btn btn-primary nextBtn"}>
                Submit
            </Button>
            </AvForm>
          </div>
        </CardBody>
      </Card>
    );
  }
}

ReviewSubmit.propTypes = {
  history: PropTypes.object
};